export const SITE_NAME='HND Study Hub'
export const SITE_DOMAIN='hndstudy.com'
export const SITE_URL='https://hndstudy.com'
export const SUPPORT_EMAIL='support@hndstudy.com'
export const DEFAULT_SOCIAL_IMAGE=`${SITE_URL}/hnd-study-hub-logo.png`


export const SOCIAL_LINKS = [
  { key:'youtube', label:'YouTube', url:'https://www.youtube.com/@HNDStudyHub' },
  { key:'facebook', label:'Facebook', url:'https://web.facebook.com/hndstudyhub/' },
  { key:'linkhub', label:'Link Hub', url:'https://wcfolio.link/hndstudyhub' },
  { key:'linkedin', label:'LinkedIn', url:'https://lk.linkedin.com/in/hnd-study-hub-b7b103381' },
] as const

export const SOCIAL_URLS = SOCIAL_LINKS.map(item=>item.url)
